import { CommonModule } from '@angular/common'
import { Component, signal } from '@angular/core'
import { InternationalizationService } from '../../../../../services/internationalization.service'
import { ChatEntity } from '../../../interfaces/chat.interface'

@Component({
  selector: 'app-group-info-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './group-info-modal.component.html',
  styleUrl: './group-info-modal.component.scss',
})
export class GroupInfoModalComponent {
  readonly isOpen = signal(false)
  readonly chat = signal<ChatEntity | null>(null)

  constructor(protected translateService: InternationalizationService) {}

  open(chat: ChatEntity): void {
    this.chat.set(chat)
    this.isOpen.set(true)
  }

  close(): void {
    this.isOpen.set(false)
  }
}
